import type { PostHog } from 'posthog-js';

import { swallowStaleChunkError } from '@/lib/chunkRecovery';

export const isPosthogEnabled = import.meta.env.VITE_ENABLE_POSTHOG === 'true';

let loader: Promise<PostHog> | null = null;

const loadPosthog = () => {
  loader ??= import('posthog-js').then(({ default: instance }) => {
    instance.init(import.meta.env.VITE_POSTHOG_PROJECTID, { api_host: 'https://us.i.posthog.com' });

    return instance;
  });

  return loader;
};

export const withPosthog = (use: (instance: PostHog) => void) => {
  if (!isPosthogEnabled) return;

  void loadPosthog().then(use, swallowStaleChunkError);
};
